module.exports = __webpack_public_path__ + "img/radar-2.51aede8a.svg";